<div class="row p-1 m-1" *ngIf="q !=='default1'" (click)="selecttemplate()">
  <!-- <div class="watermark-template" *ngIf="template" >Template{{template}}</div> -->
  <div class="col-12 d-flex">
    
    <div class="px-1"> {{QuestionNo}}.</div>   
    <div class="px-1">
      <div class="row">
        <div class="col-9">
         {{Question}}
        </div>
        <div class="col-3">
          
          <img src="assets/basic-bar-graph.png" style="
          background: grey;
          width: 20vh;
          height: 20vh;
          margin-left: 25vh;
      "/>
         </div>
      </div>
      <div class="row">
        <div class="col-12"  *ngFor="let s of answer">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" disabled="this.Question=='default'" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">{{s.answer}}</p>
              </div>
            </div>   
        </div>
        
      </div>

      <!-- <div class="row">
        <div class="col-12" *ngFor="let s of answer">
          <div class="d-flex">
            <div class="px-1 qt1-answer">
              <div class="d-flex">
                <div class="p-0">
                  <input type="radio" disabled="this.Question=='default'" class="radiobtn" name="qta1"/>
                </div>
                <div class="p-0">
                  <p class="m-0">{{s.answer}}</p>
                </div>
              </div>             
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
<div class="row p-1" *ngIf="q ==='default1'" style="
font-size: 9px !important;
">
  <!-- <div class="watermark-template-default" *ngIf="template" >Template{{template}}</div> -->
  <div class="col-12">
    <div class="px-1">
      <div class="row">
        <div class="col-9">
         1. {{Question}}
        </div>
        <div class="col-3">
          <img src="assets/basic-bar-graph.png" style="
          background: grey;
          width: 7vh;
          height: 4vh;
      "/>
         </div>
       
      </div>
      <div class="row">
        <div class="col-12"  *ngFor="let s of answer">
          <div class="d-flex  qt1-answer-default">
              <div class="p-0">
                <input type="radio" disabled="this.Question=='default'" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">{{s.answer}}</p>
              </div>
            </div>   
        </div>
        
      </div>

      <!-- <div class="row">
        <div class="col-12" *ngFor="let s of answer">
          <div class="">
            <div class="px-1 qt1-answer-default">
              <div class="d-flex">
                <div class="p-0">
                  <input type="radio" disabled="this.Question=='default'" class="radiobtn" name="qta1"/>
                </div>
                <div class="p-0">
                  <p class="m-0">{{s.answer}}</p>
                </div>
              </div>             
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>


<!-- <div class="row p-1 m-1">
  <div class="col-12 d-flex">
    <div class="px-1">1.</div>
    
    <div class="px-1">
      <div class="row pb-1">
        <div class="col-8">
          {{Question}}
        </div>
        <div class="col-4">
         <img src="../../../../../assets/basic-bar-graph.png" style="
         background: grey;
         width: 20vh;
         height: 20vh;
     "/>
        </div>
      </div>
      <div class="row">
        <div class="col-12"  *ngFor="let s of answer">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" disabled="this.Question=='default'" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">{{s.answer}}</p>
              </div>
            </div>   
        </div>
        
      </div>
    </div>
  </div>
</div> -->
<!-- <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div>
        <div class="col-12">
          <div class="d-flex  qt1-answer">
              <div class="p-0">
                <input type="radio" class="radiobtn" name="qta1"/>
              </div>
              <div class="p-0">
                <p class="m-0">Answer 1</p>
              </div>
            </div>   
        </div> -->